import { SCREEN_BREAKPOINT } from '@components/Grid/Grid.style';
import styled from '@emotion/styled';

export const BeaconPage = styled.div`
  padding: 128px 0 96px 0;
  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    padding: 96px 0;
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    padding: 64px 0 96px 0;
  }
`;

export const Layout = styled.div<{ columns?: number }>`
  display: grid;
  gap: 32px;
  max-width: 100%;
  grid-template-columns: repeat(${({ columns = 2 }) => columns}, 1fr);

  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

export const NormalCard = styled.div<{ w?: number; img: string }>`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-blend-mode: darken;
  background-color: #f8f8f8;
  border-radius: 32px;
  display: flex;
  ${({ w }) => w && `max-width : calc((1 / 2) * (${w}px - 64px));`}
  ${({ img }) => img && `background-image : url(${img});`}
    padding : 32px;
  height: 400px;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    padding: 32px;
    ${({ w }) => w && `max-width : calc((1 / 2) * (${w}px - 64px));`}
    height: 400px;
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    max-width: 100%;
    height: 400px;
    padding: 24px;

    background-size: contain;
  }
`;

export const CardTextBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const DescBox = styled.div`
  margin-top: auto;
  width: 64%;

  word-break: keep-all;

  ${SCREEN_BREAKPOINT.TABLET_MEDIA_QUERY} {
    width: 80%;
  }
  ${SCREEN_BREAKPOINT.MOBILE_MEDIA_QUERY} {
    width: 100%;
  }
`;
